import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { avatarInitial, isPlaceholderAvatarUrl } from '../../../common/views/userAvatar/avatarInitial';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the account menu and sheet */
import styles from './AccountMenu.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface AccountArtProps {
  name: string;
  avatarUrl: string | null;
  /** The red pip: a social account needs a new sign-in. */
  hasAttention?: boolean;
  size?: 'card' | 'top' | 'sheet';
}

const sizeClass = { card: styles.artCard, top: styles.artTop, sheet: styles.artSheet };

/**
 * design: navigation-v2 1a, 7a (nav2.css .acct .art, mobile.css .av2). The rounded square of the
 * account card: the artist picture, or the initial on the brand gradient. The pip mirrors the
 * Connections count. The picture is decoration; the card or button around it names the account.
 */
const AccountArtComponent: React.FC<AccountArtProps> = ({ name, avatarUrl, hasAttention = false, size = 'card' }) => {
  // A picture that fails to load shows the initial, never a broken image.
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  useEffect(() => setFailedUrl(null), [avatarUrl]);
  const image = isPlaceholderAvatarUrl(avatarUrl) || failedUrl === avatarUrl ? null : avatarUrl;
  return (
    <span className={clsx(styles.art, sizeClass[size])} aria-hidden="true">
      {image !== null ? (
        <img src={image} alt="" className={styles.artImage} onError={() => setFailedUrl(image)} />
      ) : (
        (avatarInitial(name) ?? 'M')
      )}
      {hasAttention && <span className={styles.pip} data-testid="account-attention-pip" />}
    </span>
  );
};

export const AccountArt = TypedMemo(AccountArtComponent);
